module.exports = "/images/pintrest.svg";